<template>
    <div>
        <v-container fluid v-if="trainers" class="pa-5">

            <div class="d-flex align-center py-3">
                <div>
                    <div class="display-1">Trainers</div>
                </div>
                <v-spacer></v-spacer>
                <v-btn
                        v-if="hasPermission('trainer-create')"
                        color="info"
                        dark
                        class="mb-2"
                        :to="{name: 'trainer-create'}"

                >
                    <i class="fas fa-plus mr-2"></i> New Trainer
                </v-btn>
            </div>

            <v-card>
                <v-card-title>


                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>

                    <v-switch
                            v-model="preferred"
                            label="Preferred"
                    ></v-switch>
                </v-card-title>


                <v-data-table
                        :loading="this.$apollo.queries.trainers.loading"
                        :headers="headers"
                        :items="trainers.data"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :search="search"
                        :page.sync="page"
                        :items-per-page.sync="pageCount"
                        :server-items-length="trainers.paginatorInfo.lastPage * pageCount"
                        :footer-props="{'items-per-page-options': [20, 40]}"
                >

                    <template v-slot:item.firstName="{ item }">

                            <TrainerAvatar :trainer="item" />
                            <router-link
                                    :to="{name:'trainer-view', params:{id: item.id}}"
                            >{{item.firstName}} {{item.lastName}}</router-link>
                    </template>
                    <template v-slot:item.phone="{ item }">
                        <template v-if="item.phoneMobile">
                            {{item.phoneMobile}}
                        </template>
                        <template v-else-if="item.phoneHome">
                            {{item.phoneHome}}
                        </template>
                    </template>

                    <template v-slot:item.preferred="{ item }">
                        <v-checkbox
                                v-model="item.preferred"
                                color="success"
                                readonly
                                class="shrink mr-2 mt-0 pt-0"
                                hide-details
                        ></v-checkbox>
                    </template>
                    <template v-slot:item.calendar="{ item }">
                        <v-btn
                                v-if="item.calendarUrl"
                                :href="item.calendarUrl"
                                color="primary"
                                text
                                dark
                                x-small
                        >
                            <v-icon dark>mdi-calendar</v-icon>
                            Calender
                        </v-btn>
                    </template>

                </v-data-table>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import TRAINERS_LIST from "../graphql/Trainers/TrainersList.gql";
    import TrainerAvatar from "../components/Trainer/TrainerAvatar";
    import {mapGetters} from "vuex";

    export default {
        components: {TrainerAvatar},
        metaInfo: {
            title: 'Trainers'
        },
        apollo: {
            trainers: {
                query: TRAINERS_LIST,
                variables() {

                    let where = {AND: [{column: 'PREFERRED', operator: 'EQ', value: this.preferred}]}
                    if (this.search !== '') {
                        where.AND.push({
                            'OR': [
                                {column: 'TRAINER_FIRST', operator: 'LIKE', value: '%' + this.search + '%'},
                                {column: 'TRAINER_LAST', operator: 'LIKE', value: '%' + this.search + '%'},
                            ]
                        })
                    }

                    let sortField = this.sortBy[0] ? this.sortBy[0] : 'TRAINER_FIRST'
                    let sortDirection = this.sortDesc[0] ? 'DESC' : 'ASC'

                    if (sortField === 'firstName') {
                        sortField = 'TRAINER_FIRST'
                    }

                    if (sortField === 'lastName') {
                        sortField = 'TRAINER_LAST'
                    }

                    return {
                        first: this.pageCount,
                        page: this.page,
                        where: where,
                        orderBy: {field: sortField.toUpperCase(), order: sortDirection},
                    }
                },
                update: data => data.trainers
            },
        },
        computed: {
            ...mapGetters('auth', [
                'hasPermission',
            ]),
        },
        data() {
            return {
                search: '',
                page: 1,
                pageCount: 20,
                sortBy: ['firstName'],
                sortDesc: [false],
                preferred: true,
                headers: [
                    {
                        text: 'ID',
                        align: 'start',
                        value: 'id',
                    },
                    {
                        text: 'Name',
                        align: 'start',
                        value: 'firstName',
                    },
                    {
                        text: 'Email',
                        align: 'start',
                        value: 'email',
                    },
                    {
                        text: 'Phone',
                        align: 'start',
                        value: 'phone',
                    },
                    {
                        text: 'Preferred',
                        align: 'start',
                        value: 'preferred',
                    },

                    {
                        text: 'Town',
                        align: 'start',
                        value: 'homeTown',
                    },
                    {
                        text: 'Postcode',
                        align: 'start',
                        value: 'postCode',
                    },
                    {
                        text: 'Calendar',
                        align: 'center',
                        value: 'calendar',
                    }
                ],
            }
        },
    }
</script>
